<h2 class="headline">{{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.TITLE" | translate }}</h2>
<form
  [formGroup]="form"
  (ngSubmit)="sendForm()"
  class="change-password">
  <div
    [class.error]="form.get('oldPasswordFormControl')?.invalid && form.get('oldPasswordFormControl')?.touched"
    class="input-block">
    <input
      formControlName="oldPasswordFormControl"
      id="oldPassword"
      class="input"
      type="password"
      placeholder=" " />
    <label
      for="oldPassword"
      class="placeholder">
      {{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.OLD_PASSWORD" | translate }}
    </label>
    <ng-container *ngIf="form.get('oldPasswordFormControl')?.invalid && form.get('oldPasswordFormControl')?.touched">
      <span
        *ngIf="oldPasswordRequiredError"
        class="input-block__error">
        {{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.OLD_PASSWORD_REQUIRED" | translate }}
      </span>
    </ng-container>
  </div>

  <div
    [class.error]="passwordsMatchError || (form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched)"
    class="input-block">
    <input
      formControlName="passwordFormControl"
      id="password"
      class="input"
      type="password"
      placeholder=" " />
    <label
      for="password"
      class="placeholder">
      {{ "RESET_PASSWORD.NEW_PASSWORD" | translate }}
    </label>
    <ng-container *ngIf="form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched">
      <span
        *ngIf="!passwordsMatchError && passwordRequiredError "
        class="input-block__error">
        {{ "RESET_PASSWORD.PASSWORD_REQUIRED" | translate }}
      </span>
      <span
        *ngIf="!passwordRequiredError && !passwordsMatchError &&passwordLetterFormatError"
        class="input-block__error">
        {{ "RESET_PASSWORD.LETTER_SYMBOL" | translate }}
      </span>
      <span
        *ngIf="!passwordRequiredError && !passwordLetterFormatError  && !passwordsMatchError && passwordDigitalFormatError"
        class="input-block__error">
        {{ "RESET_PASSWORD.DIGITAL_SYMBOL" | translate }}
      </span>
      <span
        *ngIf="!passwordRequiredError && !passwordLetterFormatError && !passwordDigitalFormatError && !passwordsMatchError && passwordSymbolFormatError"
        class="input-block__error">
        {{ "RESET_PASSWORD.SPECIAL_SYMBOL" | translate }}
      </span>
    </ng-container>

    <span
      *ngIf="passwordsMatchError"
      class="input-block__error">
      {{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.PASSWORDS_MATCHED" | translate }}
    </span>
  </div>

  <div
    [class.error]="passwordConfirmError && form.get('passwordFormControlConfirm')?.touched"
    class="input-block">
    <input
      formControlName="passwordFormControlConfirm"
      id="passwordConfirm"
      class="input"
      type="password"
      placeholder=" " />
    <label
      for="passwordConfirm"
      class="placeholder">
      {{ "RESET_PASSWORD.CONFIRM_PASSWORD" | translate }}
    </label>
    <ng-container *ngIf="form.get('passwordFormControlConfirm')?.touched">
      <span
        *ngIf="passwordConfirmError && !passwordConfirmRequiredError"
        class="input-block__error">
        {{ "RESET_PASSWORD.NOT_CONFIRM" | translate }}
      </span>
      <span
        *ngIf="passwordConfirmRequiredError"
        class="input-block__error">
        {{ "RESET_PASSWORD.PASSWORD_REQUIRED" | translate }}
      </span>
    </ng-container>
  </div>

  <div class="btn-block">
    <button
      [disabled]="form.invalid || passwordConfirmError"
      type="submit"
      class="btn btn-accent">
      {{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.SAVE" | translate }}
    </button>
    <button
      (click)="closeModal()"
      type="button"
      class="btn btn-light">
      {{ "PROFILE_PAGE.MODAL_CHANGE_PASSWORD.CANCEL" | translate }}
    </button>
  </div>
</form>
